<template>
    <div>
        <div class="field is-grouped">
            <div class="control">
                <router-link :to="{ name: 'branch-jackpot-create', params: { type: 'single' } }"
                             class="button is-success">
                    <span class="icon is-small">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>Create single</span>
                </router-link>
            </div>
            <div class="control">
                <router-link :to="{ name: 'branch-jackpot-create', params: { type: 'series' } }"
                             class="button is-primary">
                    <span class="icon is-small">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>Create series</span>
                </router-link>
            </div>
        </div>

        <jackpot-list :load="load" />
    </div>
</template>
<script>
import jackpotService from "../../../../../../services/jackpot.service";

import JackpotList from "../../../../../common/jackpot-list.vue";

export default {
    name: "branch-jackpots-list",
    components: { JackpotList },
    computed: {
        clientId() {
            return Number(this.$route.params.clientId);
        },
        branchName() {
            return this.$route.params.branch;
        }
    },
    methods: {
        async load(filter) {
            filter.branch = this.branchName;
            return await jackpotService.getJackpots(this.clientId, filter);
        }
    }
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/branches/branch/jackpots/list.vue